import { styled } from '@mui/material/styles'

export const StyledMainLogo = styled('img')`
  margin: 0 31px;
  width: 290px;
`
